import React from 'react'
import { Footer } from '../containers/Main'
export default function AppFooter() {
  return <Footer />
}
